import { render, staticRenderFns } from "./registerItem.vue?vue&type=template&id=51af8648&scoped=true&"
import script from "./registerItem.vue?vue&type=script&lang=js&"
export * from "./registerItem.vue?vue&type=script&lang=js&"
import style0 from "./registerItem.vue?vue&type=style&index=0&id=51af8648&scoped=true&lang=scss&"
import style1 from "./registerItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51af8648",
  null
  
)

export default component.exports